import {
    NinchatProperties, NinchatState,
} from 'api/types'
import {
    SidebarTranscriptsProps,
    SidebarTranscriptsViewProps,
} from './types'

import React from 'react'
import SidebarTranscriptsView from './SidebarTranscriptsView'
import {getGroupQueues} from 'selectors/ninchat/groups'
import {getQueueTranscripts} from 'selectors/ninchat'
import {useAppSelector} from '../../hooks'

const SidebarTranscripts = (props: SidebarTranscriptsProps): React.ReactElement => {
    const {
        parentQueueSettings,
        queue_id,
        queue_attrs,
    } = props

    const isGroupQueue = !!queue_attrs?.is_group

    const groupQueues = useAppSelector((state) => getGroupQueues(state, isGroupQueue, queue_id || ''))

    const getTranscripts = (ninchat: NinchatState) => {
        if (isGroupQueue) {
            return groupQueues.reduce<ReturnType<typeof getQueueTranscripts>>((acc, q) => {
                const transcripts = getQueueTranscripts(ninchat, q.id)
                return acc.concat(transcripts)
            }, []).sort((a, b) => (b.complete_time ?? 0) - (a.complete_time ?? 0))
        }

        if (queue_id) {
            return getQueueTranscripts(ninchat, queue_id)
        }
        return []
    }

    const sidebarTranscriptsViewProps = useAppSelector(({ninchat}): SidebarTranscriptsViewProps => {
        const transcriptsArray = getTranscripts(ninchat)
        const queueTranscripts = transcriptsArray.reduce<NinchatProperties.UserAudienceTranscripts>((acc, transcript) => {
            if (transcript.audience_id) {
                acc[transcript.audience_id] = transcript
            }
            return acc
        }, {})
        return {queueTranscripts}
    })

    return (
        <SidebarTranscriptsView
            {...sidebarTranscriptsViewProps}
            parentQueueSettings={parentQueueSettings}
        />
    )
}

export default SidebarTranscripts
